import {
  PAGE_CONTENT_TYPES,
  PageContentType,
  TAG_CONTENT_TYPES,
} from '@core/constants/contentTypes.constants';
import { FIXTURE_TYPE } from '@core/constants/fixtures.constant';
import { Route } from '@core/types/routes.types';
import templateConfig from '@templateConfig';

/**
 * Maps specific content type names to route paths.
 *
 * @param {string} typename - The name of the ContentType.
 * @param options
 * @returns {Route} Returns the route associated with the given ContentType name.
 *
 * @example
 *  const TypeName = "ArticlePage";
 *  const route = mapContentTypesWithRoutes(TypeName);
 *  console.log(route);  // Outputs: '/news/[article]'
 *  If 'typename' does not have a mapped route, it defaults to the home route '/'
 *
 *  const TypeName = "UnknownType";
 *  const route = mapContentTypesWithRoutes(TypeName);
 *  console.log(route);  // Outputs: '/'
 */
export function mapContentTypesWithRoutes(
  typename: PageContentType | typeof TAG_CONTENT_TYPES.LINK_TAG,
  options?: {
    params?: { [slug: string]: string | string[] };
    // these are the parts of the routes that aren't dynamic
    subPage?: string;
  }
): Route {
  switch (typename) {
    case PAGE_CONTENT_TYPES.ARTICLE_PAGE:
      return templateConfig.navigation.routes.ARTICLE;
    case PAGE_CONTENT_TYPES.CONTENT_PAGE:
      return templateConfig.navigation.routes.CONTENT;
    case PAGE_CONTENT_TYPES.NEWS_LISTING_PAGE:
      if (options?.params && 'newsListing' in options.params) {
        return templateConfig.navigation.routes.NEWS_LISTING_BY_SLUG;
      }
      return templateConfig.navigation.routes.NEWS_LISTING;
    case PAGE_CONTENT_TYPES.TEAM_PAGE:
      return templateConfig.navigation.routes.TEAM;
    case PAGE_CONTENT_TYPES.PROFILE_PAGE:
      return templateConfig.navigation.routes.PROFILE;
    case PAGE_CONTENT_TYPES.FIXTURE_PAGE:
      return templateConfig.navigation.routes.MATCH_CENTRE;
    case PAGE_CONTENT_TYPES.FIXTURE_LISTING_PAGE:
      if (options?.subPage && options.subPage === FIXTURE_TYPE.FIXTURES) {
        return templateConfig.navigation.routes.FIXTURES;
      }
      if (options?.subPage && options.subPage === FIXTURE_TYPE.RESULTS) {
        return templateConfig.navigation.routes.RESULTS;
      }
      if (options?.subPage && options.subPage === FIXTURE_TYPE.TABLE) {
        return templateConfig.navigation.routes.TABLE;
      }
      return templateConfig.navigation.routes.FIXTURES;
    default:
      return templateConfig.navigation.routes.HOME;
  }
}
